import { Component } from 'react'
import moment from 'moment';
import MovieTimes from './MovieTimes';
import ItemAttributes from './ItemAttributes';
import getDateYear from '../../../functions/getDateYear';
import { getFromWeekCinemaEndDate, getFromWeekCinemaStartDate } from '../../../functions/getDateFromWeek';
import setMomentDateObjZero from '../../../functions/setMomentDateObjZero';
import getMomentDateObj from '../../../functions/getMomentDateObj';
import getTranslationTime from '../../Translation/func/getTranslationTime';
import ActorDirectorInfo from './ActorDirectorInfo';
import deleteSpecialCharacters from '../../../functions/deleteSpecialCharacters';
import getImageUrl from '../../../functions/getImageUrl';
import ImageWithFallback from '../../general/ImageWithFallback';
class FlyerMovie extends Component {
    constructor(props) {
        super(props);
    }

    getHasFlyerCaptionsActive() {
        const { hasFlyerCaptions } = this.props
        const { technologyAttributes } = this.props.movieData

        if(technologyAttributes.length === 1) {
            return false
        } else {
            return hasFlyerCaptions
        }
    }

    getAttributes(hasFlyerCaptionsActive) {
        const { fsk, length, performances } = this.props.movieData
        const { currentPeriodeStartDate, currentPeriodeEndDate, generalSettings } = this.props
        const {attributeColorSettings} = generalSettings
        let attributeArr = []
        let colorToUse = 1

        performances.map(perf => {
            const {attributes, timeUtc, cinemaId} = perf

            const startDate = getMomentDateObj(currentPeriodeStartDate)
            const endDate = getMomentDateObj(currentPeriodeEndDate)
            const performanceDate = setMomentDateObjZero(getMomentDateObj(timeUtc)) //TIMEZONE MISSING
            if(startDate.isSameOrBefore(performanceDate) && performanceDate.isSameOrBefore(endDate) && cinemaId === this.props.currentCinemaId) {
                attributes.map(attr => {
                    if((attr.id === '1087' || attr.id === '2d' || attr.id === 'digital') || (attributeColorSettings[attr.id] && attributeColorSettings[attr.id].attributeColorSetting.hide)) {
                        return ''
                    } else {
                        const containsAttr = _.find(attributeArr, attrArr => {
                            return attrArr.id === attr.id
                        })

                        const styleFilter = colorToUse === 1 ? 'none' : colorToUse === 2 ? "sepia(1)" : colorToUse === 3 ? "sepia(1) invert(1) brightness(1.5)" : "invert(1)"
                        const idWithoutSpecialChars = deleteSpecialCharacters(attr.id)

                        if(!containsAttr) {
                            attributeArr.push({
                                id: attr.id,
                                name: attr.name,
                                colorToUse: colorToUse,
                                colorSettings: attributeColorSettings[idWithoutSpecialChars] && attributeColorSettings[idWithoutSpecialChars].attributeColorSetting.color,
                                displaySetting: attributeColorSettings[idWithoutSpecialChars] && attributeColorSettings[idWithoutSpecialChars].attributeColorSetting.display,
                                styleFilter: styleFilter
                            })

                            if(attributeColorSettings[idWithoutSpecialChars] && attributeColorSettings[idWithoutSpecialChars].attributeColorSetting.display === 'border') {
                                colorToUse++
                            }
                        }

                    }
                })
            }
        })

        const sortedAttributesArr = attributeArr.sort(function(a, b) {
            const attrName = a.name
            const bAttrName = b.name 
    
            return bAttrName > attrName ? -1 : bAttrName < attrName ? 1 : 0
        })

        const attributes = !hasFlyerCaptionsActive ? sortedAttributesArr : []
    
        if(fsk !== null && fsk !== -1) {
            attributes.push({
                id:'fsk',
                name: fsk
            })
        }
    
        if(length && length !== 0) {
            attributes.push({
                id:'length',
                name: length
            })
        }
    
        return attributes
    }

    getTruncateText(text, maxLength) {
        if (!text || text.length <= maxLength) {
          return text;
        }
        const shortText = text.substr(0, maxLength)
        const arr = shortText.split(" ")
        arr.pop();
        const joined = arr.join(' ');
    
        return joined + '\u2026'
    }

    getDescription() {
        const { description, movieData, style } = this.props 
        const { descriptionShort } = movieData

        if(style === 'single_movie_poster' || style === 'single_movie_background') {
            if(description && 'long' === description) {
                return movieData.description
            } else {
                return descriptionShort
            }
        } else {
            if(description && 'long' === description) {
                return descriptionShort
            } else {
                return this.getTruncateText(descriptionShort, 145)
            }
        }
    }

    getCurrentTitle() {
        const {title, titleDisplay } = this.props.movieData

        return titleDisplay ? titleDisplay : title
    }

    getPosterStyles() {
        const { images, posterURL } = this.props.movieData
        const {colors} = this.props
        const {border_radius_posters} = colors
        const { poster } = images
        const posterUrlStyle = poster ? poster.url : posterURL ? posterURL : ''
        const {finalImageURl, imageUrl } = getImageUrl(posterUrlStyle, false, false, false, true, true)

        return {
            finalImageURl,
            imageUrl,
            borderRadius: border_radius_posters
        }
    }

    getBackgroundStyles() {
        const { images } = this.props.movieData
        const { ambient, backgrounds } = images

        const backgroundUrl = backgrounds && backgrounds.length !== 0 ? backgrounds[0].url : ''
        const ambientUrlStyle = (ambient && ambient.url) || backgroundUrl || ''
        const {finalImageURl, imageUrl } = getImageUrl(ambientUrlStyle, false, false, false, true, true)

        return {
            finalImageURl,
            imageUrl
        }
    }

    getMovieTimesText() {
        moment.locale('de');
        const { periodesDays, translation } = this.props
        const {debug} = translation
        let movieTimesText = ''
        const weekDays = moment().localeData("de").weekdays(true)
        
        // need to sort after day name to display "Mittwochs, 09. und 23. April 2025"
        const sortedAfterDayKeys = {}
        _.keys(periodesDays).map((periodesDayKey) => {
            const dayKey = moment(periodesDayKey).locale("de").weekday()
            const periodeDayItems = periodesDays[periodesDayKey]
            
            if(periodeDayItems.length > 0) {
                if(_.has(sortedAfterDayKeys, dayKey)) {
                    periodeDayItems.map((periodeDayItem) => {
                        sortedAfterDayKeys[dayKey].push(periodeDayItem)
                    })
                } else {
                    sortedAfterDayKeys[dayKey] = periodeDayItems
                }
            }
        })

        
        _.keys(sortedAfterDayKeys).map(((dayKey, dayindex) => {
            if(_.keys(sortedAfterDayKeys).length === 1) {
                const dayKeysDays = sortedAfterDayKeys[dayKey]
                movieTimesText += weekDays[dayKey] + ', '
                

                dayKeysDays.map((day, index) => {
                    const before = dayKeysDays.length !== 1 ? index === (dayKeysDays.length - 1) ? ' und ' : index !== 0 ? ', ' : '' : ''
                    const date = getTranslationTime("dateWithMothName", "Europe/Berlin", "de", day.timeUtc, debug, before)
                    movieTimesText += date
                })
            } else if (_.keys(sortedAfterDayKeys).length > 1) {
                const dayKeysDays = sortedAfterDayKeys[dayKey]
                const before = _.keys(sortedAfterDayKeys).length !== 1 ? dayindex === (_.keys(sortedAfterDayKeys).length - 1) ? ' und ' : dayindex !== 0 ? ', ' : '' : ''
                movieTimesText += before + weekDays[dayKey] + ', '

                dayKeysDays.map((day, index) => {
                    const before = dayKeysDays.length !== 1 ? index === (dayKeysDays.length - 1) ? ' und ' : index !== 0 ? ', ' : '' : ''
                    const date = getTranslationTime("dateWithMothName", "Europe/Berlin", "de", day.timeUtc, debug, before)
                    movieTimesText += date
                })
            }
        }))

        return movieTimesText
    }

    render() {
        const { movieData, movieTimesDesktop, colors, iconsColor, hideTheatres, hideEmptyDays, translation, generalSettings, cinemaData, captionAttributes, hasFlyerCaptions, periodesDays, style } = this.props
        const {title, performances, actors, directors } = movieData
        const { accent_color_dark, theme_colors, accent_color, chosen_font} = colors
        const accentColorDark = accent_color_dark
        const accentColor = accent_color
        const currentTitle = this.getCurrentTitle()
        const posterStyles = this.getPosterStyles()
        const backgroundStyles = this.getBackgroundStyles()
        const hasFlyerCaptionsActive = this.getHasFlyerCaptionsActive()
        const attributes = this.getAttributes(hasFlyerCaptionsActive)
        const isExtended = style === 'extended'
        const hasPoster = style === 'single_movie_poster'
        const hasBackground = style === 'single_movie_background'
        const movieTimesText = hasPoster && this.getMovieTimesText()

        return (
            <div className={"slide-item" + ' style-' + style}>
                {hasPoster && <div className={`${chosen_font}-text-small-black poster-dates`}>{movieTimesText}</div>}
                {hasBackground && <div className={"background-format-item " + style}>
                    <div className="background">
                        {(backgroundStyles.finalImageURl || backgroundStyles.imageUrl) && <ImageWithFallback
                            src={backgroundStyles.finalImageURl}
                            srcFallback={backgroundStyles.imageUrl}
                            alt=""
                            style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
                        />}
                        <p className="screen-reader-text">{title} Hintergrund</p>
                    </div>
                </div> }
                <div className="movie-information-wrapper">
                    {(isExtended || hasPoster) && (posterStyles ? (
                        <div>
                            <div className={"poster-format-item " + style}>
                                <div className="poster" style={{ borderRadius: posterStyles.borderRadius }}>
                                    {(posterStyles.finalImageURl || posterStyles.imageUrl) && <ImageWithFallback
                                        src={posterStyles.finalImageURl}
                                        srcFallback={posterStyles.imageUrl}
                                        alt=""
                                        style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
                                    />}
                                </div>
                                <p className="screen-reader-text">{title} Filmposter</p>
                            </div>
                            {(hasPoster && attributes.length !== 0) && <div className="attributes-wrapper">
                                <ItemAttributes 
                                    hide2d={hasFlyerCaptions ? false : true} 
                                    accentColorDark={accentColorDark} 
                                    accentColor={accentColor} 
                                    chosen_font={chosen_font} 
                                    translation={translation} 
                                    performances={performances} 
                                    themeColors={theme_colors} 
                                    attributes={attributes}
                                    iconsColor={iconsColor}
                                />
                            </div>}
                        </div>
                    ) : (
                        <div>
                            <div className={"no-image-container " + style}>
                                <div className="no-image"><span className="screen-reader-text">{title}</span></div>
                            </div>
                            {(hasPoster && attributes.length !== 0) && <div className="attributes-wrapper">
                                <ItemAttributes 
                                    hide2d={hasFlyerCaptions ? false : true} 
                                    accentColorDark={accentColorDark} 
                                    accentColor={accentColor} 
                                    chosen_font={chosen_font} 
                                    translation={translation} 
                                    performances={performances} 
                                    themeColors={theme_colors} 
                                    attributes={attributes}
                                    iconsColor={iconsColor}
                                />            
                            </div>}
                        </div>
                    ))}

                    <div className="inner-movie-information">
                        <div className='info-wrapper'>
                            {currentTitle && <h2 className={`movie-title ${chosen_font}-text-small-black`}>
                                {currentTitle}
                            </h2>}

                            {(!hasPoster && attributes.length !== 0) && <div className="attributes-wrapper">
                                <ItemAttributes 
                                    hide2d={hasFlyerCaptions ? false : true} 
                                    accentColorDark={accentColorDark} 
                                    accentColor={accentColor} 
                                    chosen_font={chosen_font} 
                                    translation={translation} 
                                    performances={performances} 
                                    themeColors={theme_colors} 
                                    attributes={attributes}
                                    iconsColor={iconsColor}
                                    />            
                            </div>}
                        </div>

                        {(isExtended || hasBackground || hasPoster) && <div className={`description ${chosen_font}-text-xxsmall-light`}>
                            {this.getDescription()}
                        </div>}

                        {hasBackground && 
                            <div className='actor-director-wrapper'>
                                <ActorDirectorInfo actors={actors} directors={directors} translation={translation}/>
                            </div>
                        }

                        {(!hasPoster) && <MovieTimes
                            reducedVersion={true}
                            flyerDate={true}
                            cinemaData={cinemaData}
                            generalSettings={generalSettings}
                            translation={translation}
                            itemStyle={style}
                            chosen_font={chosen_font} 
                            hideEmptyDays={hideEmptyDays}
                            attributesColors={attributes}
                            showMovieTimesSortedAfterTheatres={movieTimesDesktop}
                            periodesDays={periodesDays}
                            hasFlyerCaptions={hasFlyerCaptionsActive}
                            captionAttributes={captionAttributes}
                            movieData = {movieData}
                            performances={performances}
                            hideTheatres={hideTheatres}
                            colors={colors}
                            iconsColor={iconsColor}
                        />}
                    </div>
                </div>
            </div>

        )
    }
}

export default FlyerMovie